<template>
  <div id="item-yelp-review">
    <vx-card class="mt-3">
      <vs-row class="font-medium pb-3 flex justify-center md:justify-start">
        <div v-if="reviewData.avatar != null" class="w-1/12">
          <vs-avatar size="55px" :src="reviewData.avatar"/>
        </div>
        <div v-else class="w-1/12">
          <vs-avatar size="55px" :text="StringHelper.changeFormatAvatar(reviewData.user_name)" class="text-3xl"/>
        </div>
        <div class="flex flex-col ml-0 justify-around w-11/12 pl-base">
          <div class="font-bold mt-3 mb-5 text-lg flex align-center mx-auto md:ml-0">
            <span class="color-black">{{reviewData.user_name}}</span>
            <img src="../../../assets/images/logo/yelp.svg" width="20" height="20" class="ml-4" style="margin-top: 1px"/>
          </div>
          <div>
            <span class="vs-col w-1/2 mb-3">
              <feather-icon icon="PhoneIcon" svgClasses="w-4 h-4 stroke-current" class="w-1/12" />
              <span v-if="reviewData.customer">{{StringHelper.phoneNumberFormat(reviewData.customer.phone)}}</span>
              <span v-else>N/A</span>
            </span>
            <span class="vs-col w-1/2 mb-3">
              Last visit:
              <span v-if="reviewData.customer">{{changeFormat(reviewData.customer.last_visited)}}</span>
              <span v-else class="pr-6">N/A</span>
            </span>
            <span class="vs-col w-1/2">
              <feather-icon icon="MailIcon" svgClasses="w-4 h-4 stroke-current" class="w-1/12" />
              <span class="d-inline-block" style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap; transform: translateY(4px)" v-if="reviewData.customer">{{reviewData.customer.email}}</span>
              <span class="d-inline-block" style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap; transform: translateY(4px)" v-else>N/A</span>
            </span>
            <span class="vs-col w-1/2">
              Visit
              <span v-if="reviewData.customer">{{reviewData.customer.visit_count}}</span>
              <span v-else>N/A</span> times
            </span>
          </div>
        </div>
      </vs-row>
      <vs-divider></vs-divider>
      <div>
        <vs-row class="font-medium py-3 flex align-center">
          <img src="../../../assets/images/logo/yelp.svg" width="40" height="40" class="ml-1"/>
          <span class="font-bold ml-3 text-lg color-black">Yelp Reviews</span>
        </vs-row>
        <vs-row class="flex align-center">
          <star-rating :rating="reviewData.rating" :read-only="true" :increment="1"></star-rating>
          <span class="ml-4 day font-light">{{changeFormat(reviewData.time_create)}}</span>
        </vs-row>
        <p>{{reviewData.content}}</p>
      </div>
    </vx-card>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import { StringHelper } from "../../../models/string_helper";
import {changeFormatWithDateTime} from '../../../helper/datetimeHelper';
// import moment from 'moment';
export default {
  name: "item-yelp-review",
  components: {
      StarRating
  },
  props: {
    reviewData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      StringHelper
    };
  },
  methods: {
    changeFormat(day){
      if(day) {
        return changeFormatWithDateTime(day);
      } else {
        return 'N/A';
      }
    }
  }
};
</script>
